import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=498dc0bd&"
import script from "./MenuIcon.vue?vue&type=script&lang=js&"
export * from "./MenuIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports